export default __webpack_public_path__ + "5a06960be7b65482ce2cfa785202dba0.jpg";